import { render } from "./venue-carousel.vue?vue&type=template&id=1735b758"
import script from "./venue-carousel.vue?vue&type=script&lang=js"
export * from "./venue-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__